module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_19.96c89f95.jpg";